import UploadBulkImages from "./UploadBulkImages";

export default UploadBulkImages;
